'use client';
import React, { useMemo } from 'react';

import { StyledLink } from './index.styled';
import { LOCALE_TO_LANGUAGE, LOCALES } from '@/i18n';
import { Item } from '@/ui/components/HoverMenu';
// import Link from '@/ui/components/Link';

export const usePrepareOptions = ({ languageOptions, changeLanguage, pathname, hash = '' }) => {
  return useMemo((): Item[] => {
    // If we have language options from global state, use those
    if (languageOptions && languageOptions.length > 0) {
      return languageOptions.map(option => ({
        label: (
          <StyledLink href={option.path}>
            <span style={{ color: 'black' }}>{LOCALE_TO_LANGUAGE[option.locale]}</span>
          </StyledLink>
        ),
        action: () => {},
      }));
    }

    // Fallback to pathname-based approach
    const link = `/${pathname.replace(/^\/(en|cs|pl|de|fr|es|it|ja)/, '')}`;
    const hashFragment = hash ? `#${hash}` : '';

    return LOCALES.map(locale => ({
      label: (
        <StyledLink href={`/${locale}${link}${hashFragment}`.replace(/\/\//g, '/')}>
          <span style={{ color: 'black' }}>{LOCALE_TO_LANGUAGE[locale]}</span>
        </StyledLink>
      ),
      action: () => {},
    }));
  }, [languageOptions, changeLanguage, pathname, hash]);
};
